import axios from "axios";
import { InvoiceItemType } from "../../../types";

import { CreateInvoiceFormContent } from "./validation";

export interface CreateInvoiceParams {
  data: CreateInvoiceFormContent;
  invoiceTarget: InvoiceItemType;
  transactionNumbers: string[];
}

export const createInvoice = ({
  data: { attachments, isAdjustment, amount, comment },
  invoiceTarget,
  transactionNumbers,
}: CreateInvoiceParams) =>
  axios
    .post<{ number: string }>(`/invoices/rate`, {
      invoiceTarget,
      transactionNumbers,
      attachments,
      ...(isAdjustment ? { adjustment: { amount, comment } } : {}),
    })
    .then((res) => res.data);
